import type { AttiExperience } from 'events/ops/opsEvent';

const timestamps = new Map<AttiExperience, number>();

export function recordActionTimestamp(experience: AttiExperience): void {
  timestamps.set(experience, Date.now());
}

export function consumeActionTimestamp(experience: AttiExperience): number | undefined {
  const ts = timestamps.get(experience);
  if (ts !== undefined) {
    timestamps.delete(experience);
  }
  return ts;
}
